import { NodeId } from 'web';
import type { FlowGraph } from '../FlowGraph';

export class PreviewView {
  constructor(
    private graph: FlowGraph,
    private id: NodeId,
  ) {}

  evaluateImageInputUrl(): string | undefined {
    const evaluatedFile = this.graph.evaluateInput(this.id, 'file');
    if (evaluatedFile?.type !== 'image') {
      return undefined;
    }

    if (evaluatedFile.value.type === 'file') {
      return evaluatedFile.value.url;
    }

    // Handle computed images by rendering them
    const computedImage = this.graph.wasm.call((wasm) => wasm.exportNodeRender(this.id));
    return computedImage?.data;
  }
}
